import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from 'lucide-react';
interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  readTime: number;
  date: string;
}
export const BlogSection = () => {
  const posts: BlogPost[] = [{
    id: '1',
    title: 'HOW TO SELL YOUR WINDOWS LAPTOP',
    excerpt: 'Learn the best practices for preparing your Windows laptop for sale and maximizing its value.',
    image: 'https://images.pexels.com/photos/6802049/pexels-photo-6802049.jpeg',
    readTime: 5,
    date: 'May 10, 2023'
  }, {
    id: '2',
    title: '6 COMMON MYTHS ABOUT SMARTPHONE BATTERIES',
    excerpt: 'Debunking common misconceptions about smartphone batteries and how to properly care for them.',
    image: 'https://images.pexels.com/photos/4195325/pexels-photo-4195325.jpeg',
    readTime: 7,
    date: 'April 28, 2023'
  }, {
    id: '3',
    title: 'SAMSUNG GALAXY S24 ULTRA THE PINNACLE OF',
    excerpt: "A comprehensive review of Samsung's latest flagship phone and its groundbreaking features.",
    image: 'https://images.pexels.com/photos/404280/pexels-photo-404280.jpeg',
    readTime: 10,
    date: 'April 15, 2023'
  }, {
    id: '4',
    title: '6 ESSENTIAL TIPS TO EXTEND YOUR',
    excerpt: 'Practical advice for extending the lifespan of your electronic devices and maximizing their value.',
    image: 'https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg',
    readTime: 6,
    date: 'April 5, 2023'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-876">
      <div className="container mx-auto px-4" data-id="element-877">
        <div className="flex justify-between items-center mb-8" data-id="element-878">
          <h2 className="text-3xl font-bold text-gray-800" data-id="element-879">From our blog</h2>
          <Link to="/blog" className="text-blue-600 hover:underline font-medium" data-id="element-880">
            View all articles
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-881">
          {posts.map(post => <Link key={post.id} to={`/blog/${post.id}`} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-882">
              <div className="h-48 overflow-hidden" data-id="element-883">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-300" data-id="element-884" />
              </div>
              <div className="p-5" data-id="element-885">
                <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-886">
                  <span data-id="element-887">{post.date}</span>
                  <span className="mx-2" data-id="element-888">•</span>
                  <div className="flex items-center" data-id="element-889">
                    <ClockIcon className="h-4 w-4 mr-1" data-id="element-890" />
                    <span data-id="element-891">{post.readTime} min read</span>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-892">
                  {post.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-893">{post.excerpt}</p>
                <div className="mt-4 text-blue-600 font-medium hover:underline inline-block" data-id="element-894">
                  Read more
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
};